// src/services/produtos/ProdutoApresentacaoService.js
import { fetchData } from '../Api';

export const buscarApresentacoesPorProduto = (produtoId) =>
    fetchData(`/ProdutoApresentacao/GetTodosCadByProdutoId?produtoId=${produtoId}`);
